interface Props {
  value?: number;
  count?: number;
  size?: number;
}

export function StarRating({ value = 0, count = 0, size = 14 }: Props) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  const stars = Array.from({ length: 5 }).map((_, i) => {
    if (i < full) return "full";
    if (i === full && half) return "half";
    return "empty";
  });
  return (
    <div className="flex items-center gap-1.5">
      <div className="flex" style={{ fontSize: size }}>
        {stars.map((s, i) => {
          const cls =
            s === "half" ? "star-half" : s === "full" ? "star-fill" : "star-empty";
          return (
            <span key={i} className={cls}>
              {s === "empty" ? "☆" : "★"}
            </span>
          );
        })}
      </div>
      {value > 0 && (
        <span className="text-sm font-medium text-slate-900">
          {value.toFixed(2)}
        </span>
      )}
      {count > 0 && (
        <span className="text-xs text-slate-500">
          ({count >= 1000 ? `${Math.round(count / 100) / 10}k` : count})
        </span>
      )}
    </div>
  );
}
